import { TFunction } from 'i18next';

import {
  AssignmentsViewOptions,
  MSAssignmentsStatusOptions,
} from 'src/interfaces/assignment.types';

// Labels are for UI views, not API work types
export const getAssignmentsStatusLabelMap = (
  t: TFunction,
): Record<AssignmentsViewOptions, string> => ({
  [AssignmentsViewOptions.APPS]: t('Apps'),
  [AssignmentsViewOptions.TODO]: t('To Do'),
  [AssignmentsViewOptions.PAST_WORK]: t('Past Work'),
});

export const getMSAssignmentsStatusLabelMap = (
  t: TFunction,
): Record<MSAssignmentsStatusOptions, string> => ({
  [MSAssignmentsStatusOptions.STARTED]: t('Started'),
  [MSAssignmentsStatusOptions.NOT_STARTED]: t('Not Started'),
  [MSAssignmentsStatusOptions.HANDED_IN]: t('Handed In'),
});

export const MSAssignmentsStatusAriaLabelMap: Record<
  MSAssignmentsStatusOptions,
  string
> = {
  [MSAssignmentsStatusOptions.STARTED]: 'Show only in-progress assignments',
  [MSAssignmentsStatusOptions.NOT_STARTED]: 'Show only unstarted assignments',
  [MSAssignmentsStatusOptions.HANDED_IN]:
    'Show only assignments that are handed in',
};
